import Swal from 'sweetalert2'
import moment from 'moment';

export default {
    name: 'Add',
    created() {

        this.GetMunicipalities();
        this.GetDevices();
    },
    components: {

       
       
    },
    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('MMMM Do YYYY');
        }
    },
    data() {
        return {
            AllDevices : [],
            Municipalities:[],
            ruleForm: {
                Name: '',
                MunicipalitId: '',
                EngilshName: '',
                Devicelist: [],
                //TriggersCount: 0,
                //ChairCount: 0,
            },
            rules: {
                MunicipalitId: [
                    { required: true, message: 'الرجاء  اختيار البلدية', trigger: 'blur' },
                ],

                Name: [
                    { required: true, message: 'الرجاء إدخال إسم المدينة', trigger: 'blur' },
                    { required: true, pattern: /[\u0600-\u06FF]/, message: 'الرجاء إدخال حروف العربية فقط', trigger: 'blur' }
                ],

                EngilshName: [
                    { required: true, message: 'الرجاء إدخال إسم المدينة', trigger: 'blur' },
                    { required: true, pattern: /^[a-zA-Z ]+$/, message: 'الرجاء إدخال حروف انجليزية فقط', trigger: 'blur' }
                ],

                //ChairCount: [
                //    { required: true, message: 'الرجاء إدخال عدد المشغلات', trigger: 'blur' },
                //],

                //TriggersCount: [
                //    { required: true, message: 'الرجاء إدخال عدد المشغلات', trigger: 'blur' },
                //],
            },
            
        };
    },
    methods: {

        GetMunicipalities() {
            this.$blockUI.Start();
            this.$http.GetAllMunicipalities()
                .then(response => {
                    this.$blockUI.Stop();
                    this.Municipalities = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });

        },

        GetDevices() {
            this.$blockUI.Start();
            this.$http.GetListDevice()
                .then(response => {
                    this.$blockUI.Stop();
                    this.AllDevices = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });

        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.AddCity(formName);
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.ruleForm.Devicelist = [];
            this.AllDevices= [];
        },
      
        AddCity(formName) {
           
            this.$blockUI.Start();
            
            this.ruleForm.Devicelist = this.AllDevices;
            this.$http.AddHospitals(this.ruleForm)
                .then(response => {
                    this.resetForm(formName);
                    this.$blockUI.Stop();
                    Swal.fire({
                        icon: 'success',
                        title: '..نجـاح العملية',
                        // text: '<strong>Something went wrong!</strong>',
                        html:
                            response.data,
                        // showCloseButton: true,
                        showCancelButton: false,
                        //confirmButtonText: `حـفظ`,
                        //denyButtonText: `مواق`,
                    }).then(() => {
                        
                    });
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.$notify({
                        title: 'خطأ بعملية الاضافة',
                        dangerouslyUseHTMLString: true,
                        type: 'error',
                        message: err.response.data
                    });
                });
        }


        

    }
}
